module.exports = __webpack_public_path__ + "static/media/inviter-title.91e1730c.png";